import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider, useMediaQuery } from '@mui/material';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import { withTranslation } from 'react-i18next';
import { EUR_CURRENCY, filterRangeValues } from '../../constants';
import { Card, Slider, Typography } from '@totalsoft/rocket-ui';
import {
  BoldTextWrapper,
  AssetDetailSliderWrapper,
  IconCardWrapper,
  OfferGridWrapper,
  AssetImageWrapper,
  AssetDetailWrapper
} from 'features/simulator/SimulatorStyles';

const SimulatorAssetComponent = ({ t, assetInfo, handleAssetInfoFiltersChange }) => {
  const matchesLg = useMediaQuery('(min-width:1280px)');
  const matchesSm = useMediaQuery('(max-width:750px)');
  const matchesMd = useMemo(() => !matchesLg && !matchesSm, [matchesLg, matchesSm]);

  return (
    <OfferGridWrapper item xs={12} lg={4} matchesLg={matchesLg}>
      <Card icon={DriveEtaIcon} iconColor='primary'>
        <Grid container>
          <AssetImageWrapper item matchesMd={matchesMd}>
            {<IconCardWrapper src={assetInfo.imageUrl} alt='...' />}
            {!matchesMd && <Divider light />}
          </AssetImageWrapper>
          <AssetDetailWrapper item container matchesMd={matchesMd}>
            <Grid item container sx={{ width: '100%' }}>
              <Grid item xs={5}>
                <Typography fontSize='15px' align='left'>
                  {t('Simulator.Results.ListPrice')}:
                </Typography>
              </Grid>
              <BoldTextWrapper>
                {t('DECIMAL2', { number: assetInfo.listPrice })} {EUR_CURRENCY}
              </BoldTextWrapper>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                <Typography fontSize='15px' align='left'>
                  {t('Simulator.Filters.FinancingPeriod')}:
                </Typography>
              </Grid>
              <AssetDetailSliderWrapper item xs={7}>
                <Slider
                  id={'simulatorAssetComponent_financingPeriod'}
                  value={assetInfo.financingPeriod}
                  min={filterRangeValues.financingPeriod.minValue}
                  max={filterRangeValues.financingPeriod.maxValue}
                  step={filterRangeValues.financingPeriod.step}
                  decimalScale={0}
                  fullWidth={true}
                  required
                  showSliderLimits
                  onChange={handleAssetInfoFiltersChange('financingPeriod')}
                />
              </AssetDetailSliderWrapper>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                <Typography fontSize='15px' align='left'>
                  {t('Simulator.Filters.Advance')}:
                </Typography>
              </Grid>
              <AssetDetailSliderWrapper item xs={7}>
                <Slider
                  value={assetInfo.advance}
                  min={filterRangeValues.advance.minValue}
                  max={filterRangeValues.advance.maxValue}
                  step={filterRangeValues.advance.step}
                  decimalScale={0}
                  fullWidth={true}
                  required={true}
                  showSliderLimits={true}
                  onChange={handleAssetInfoFiltersChange('advance')}
                />
              </AssetDetailSliderWrapper>
            </Grid>
          </AssetDetailWrapper>
        </Grid>
      </Card>
    </OfferGridWrapper>
  );
};
SimulatorAssetComponent.propTypes = {
  t: PropTypes.func.isRequired,
  assetInfo: PropTypes.object.isRequired,
  handleAssetInfoFiltersChange: PropTypes.func.isRequired
};

export default withTranslation()(SimulatorAssetComponent);
